// This is based on Ruby's email validation:
// /\A([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})\z/i
// .. but Sendgrid to not support special characters like æøå, so the
// first path ([^@\s]+) is switched out with a more restrictive
// pattern taken from Wikipedia's page about email addresses.
export const EMAIL_REGEX = /^([a-z0-9.!#$%&'*+-/=?^_`{|}~]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i

export function addVat(amount, RATE = 1.25) {
  return Math.round(amount * RATE)
}

export function formatKm(km) {
  return `${km.toFixed(1)} km`
}

export function formatPrice(price, suffix = ',-') {
  if (typeof price !== 'number') {
    throw TypeError(`The price ${price} must be a number but was ${typeof price}`)
  }

  return [
    Number(Math.round(price, 0)).toLocaleString('nb-NO'),
    suffix,
  ].join('')
}

export function sumBy(array, iterator) {
  return array.reduce((acc, item) => {
    return acc + iterator(item)
  }, 0)
}

export function groupBy(array, iterator) {
  return array.reduce((acc, item) => {
    const value = iterator(item)
    if (acc[value]) {
      acc[value].push(item)
    } else {
      acc[value] = [item]
    }
    return acc
  }, {})
}

// Retreive type and id from an ID generated by relay
// Example: VHlwZTox -> {type: 'Type', id: 1}
// In case we want to parse a global id to retreive type and id
export function fromGlobalId(globalId) {
  const [, type, id] = atob(globalId).match(/(.*?):(.*)/)
  return {type, id}
}

export function withHumanDelimiters(array, {delimiter = ', ', lastDelimiter = ' og '} = {}) {
  const delimitersLength = array.length - 2
  return array.reduce((acc, item, i) => {
    acc += item
    if (i === delimitersLength) acc += lastDelimiter
    if (i < delimitersLength) acc += delimiter
    return acc
  }, '')
}

export function getVimeoCodeFromUrl(url) {
  return url.substring(url.lastIndexOf('/') + 1)
}
